package devxertech.com.pages.contactSection

/**
 * Country names and ISO codes derive from mledoze/countries (ODbL-1.0):
 * https://github.com/mledoze/countries/blob/master/countries.json
 * https://opendatacommons.org/licenses/odbl/1-0/
 * International calling codes derive from intl-tel-input (MIT), which attributes
 * its country data to mledoze/countries and libphonenumber:
 * https://github.com/jackocnr/intl-tel-input/blob/master/packages/core/src/js/data.ts
 * https://github.com/jackocnr/intl-tel-input/blob/master/LICENSE
 * Snapshot bundled on 2026-10-02.
 * This is the complete set supported by that phone-input dataset. Each calling code
 * is the international country calling code; regional area-code suffixes are not appended.
 */
internal data class CountryDataRecord(val name: String, val iso: String, val callingCode: String)

internal val bundledCountryData = listOf(
    CountryDataRecord(name = "Afghanistan", iso = "AF", callingCode = "+93"),
    CountryDataRecord(name = "Åland Islands", iso = "AX", callingCode = "+358"),
    CountryDataRecord(name = "Albania", iso = "AL", callingCode = "+355"),
    CountryDataRecord(name = "Algeria", iso = "DZ", callingCode = "+213"),
    CountryDataRecord(name = "American Samoa", iso = "AS", callingCode = "+1"),
    CountryDataRecord(name = "Andorra", iso = "AD", callingCode = "+376"),
    CountryDataRecord(name = "Angola", iso = "AO", callingCode = "+244"),
    CountryDataRecord(name = "Anguilla", iso = "AI", callingCode = "+1"),
    CountryDataRecord(name = "Antigua and Barbuda", iso = "AG", callingCode = "+1"),
    CountryDataRecord(name = "Argentina", iso = "AR", callingCode = "+54"),
    CountryDataRecord(name = "Armenia", iso = "AM", callingCode = "+374"),
    CountryDataRecord(name = "Aruba", iso = "AW", callingCode = "+297"),
    CountryDataRecord(name = "Ascension Island", iso = "AC", callingCode = "+247"),
    CountryDataRecord(name = "Australia", iso = "AU", callingCode = "+61"),
    CountryDataRecord(name = "Austria", iso = "AT", callingCode = "+43"),
    CountryDataRecord(name = "Azerbaijan", iso = "AZ", callingCode = "+994"),
    CountryDataRecord(name = "Bahamas", iso = "BS", callingCode = "+1"),
    CountryDataRecord(name = "Bahrain", iso = "BH", callingCode = "+973"),
    CountryDataRecord(name = "Bangladesh", iso = "BD", callingCode = "+880"),
    CountryDataRecord(name = "Barbados", iso = "BB", callingCode = "+1"),
    CountryDataRecord(name = "Belarus", iso = "BY", callingCode = "+375"),
    CountryDataRecord(name = "Belgium", iso = "BE", callingCode = "+32"),
    CountryDataRecord(name = "Belize", iso = "BZ", callingCode = "+501"),
    CountryDataRecord(name = "Benin", iso = "BJ", callingCode = "+229"),
    CountryDataRecord(name = "Bermuda", iso = "BM", callingCode = "+1"),
    CountryDataRecord(name = "Bhutan", iso = "BT", callingCode = "+975"),
    CountryDataRecord(name = "Bolivia", iso = "BO", callingCode = "+591"),
    CountryDataRecord(name = "Bosnia and Herzegovina", iso = "BA", callingCode = "+387"),
    CountryDataRecord(name = "Botswana", iso = "BW", callingCode = "+267"),
    CountryDataRecord(name = "Brazil", iso = "BR", callingCode = "+55"),
    CountryDataRecord(name = "British Indian Ocean Territory", iso = "IO", callingCode = "+246"),
    CountryDataRecord(name = "British Virgin Islands", iso = "VG", callingCode = "+1"),
    CountryDataRecord(name = "Brunei", iso = "BN", callingCode = "+673"),
    CountryDataRecord(name = "Bulgaria", iso = "BG", callingCode = "+359"),
    CountryDataRecord(name = "Burkina Faso", iso = "BF", callingCode = "+226"),
    CountryDataRecord(name = "Burundi", iso = "BI", callingCode = "+257"),
    CountryDataRecord(name = "Cambodia", iso = "KH", callingCode = "+855"),
    CountryDataRecord(name = "Cameroon", iso = "CM", callingCode = "+237"),
    CountryDataRecord(name = "Canada", iso = "CA", callingCode = "+1"),
    CountryDataRecord(name = "Cape Verde", iso = "CV", callingCode = "+238"),
    CountryDataRecord(name = "Caribbean Netherlands", iso = "BQ", callingCode = "+599"),
    CountryDataRecord(name = "Cayman Islands", iso = "KY", callingCode = "+1"),
    CountryDataRecord(name = "Central African Republic", iso = "CF", callingCode = "+236"),
    CountryDataRecord(name = "Chad", iso = "TD", callingCode = "+235"),
    CountryDataRecord(name = "Chile", iso = "CL", callingCode = "+56"),
    CountryDataRecord(name = "China", iso = "CN", callingCode = "+86"),
    CountryDataRecord(name = "Christmas Island", iso = "CX", callingCode = "+61"),
    CountryDataRecord(name = "Cocos (Keeling) Islands", iso = "CC", callingCode = "+61"),
    CountryDataRecord(name = "Colombia", iso = "CO", callingCode = "+57"),
    CountryDataRecord(name = "Comoros", iso = "KM", callingCode = "+269"),
    CountryDataRecord(name = "Congo", iso = "CG", callingCode = "+242"),
    CountryDataRecord(name = "DR Congo", iso = "CD", callingCode = "+243"),
    CountryDataRecord(name = "Cook Islands", iso = "CK", callingCode = "+682"),
    CountryDataRecord(name = "Costa Rica", iso = "CR", callingCode = "+506"),
    CountryDataRecord(name = "Ivory Coast", iso = "CI", callingCode = "+225"),
    CountryDataRecord(name = "Croatia", iso = "HR", callingCode = "+385"),
    CountryDataRecord(name = "Cuba", iso = "CU", callingCode = "+53"),
    CountryDataRecord(name = "Curaçao", iso = "CW", callingCode = "+599"),
    CountryDataRecord(name = "Cyprus", iso = "CY", callingCode = "+357"),
    CountryDataRecord(name = "Czechia", iso = "CZ", callingCode = "+420"),
    CountryDataRecord(name = "Denmark", iso = "DK", callingCode = "+45"),
    CountryDataRecord(name = "Djibouti", iso = "DJ", callingCode = "+253"),
    CountryDataRecord(name = "Dominica", iso = "DM", callingCode = "+1"),
    CountryDataRecord(name = "Dominican Republic", iso = "DO", callingCode = "+1"),
    CountryDataRecord(name = "Ecuador", iso = "EC", callingCode = "+593"),
    CountryDataRecord(name = "Egypt", iso = "EG", callingCode = "+20"),
    CountryDataRecord(name = "El Salvador", iso = "SV", callingCode = "+503"),
    CountryDataRecord(name = "Equatorial Guinea", iso = "GQ", callingCode = "+240"),
    CountryDataRecord(name = "Eritrea", iso = "ER", callingCode = "+291"),
    CountryDataRecord(name = "Estonia", iso = "EE", callingCode = "+372"),
    CountryDataRecord(name = "Eswatini", iso = "SZ", callingCode = "+268"),
    CountryDataRecord(name = "Ethiopia", iso = "ET", callingCode = "+251"),
    CountryDataRecord(name = "Falkland Islands", iso = "FK", callingCode = "+500"),
    CountryDataRecord(name = "Faroe Islands", iso = "FO", callingCode = "+298"),
    CountryDataRecord(name = "Fiji", iso = "FJ", callingCode = "+679"),
    CountryDataRecord(name = "Finland", iso = "FI", callingCode = "+358"),
    CountryDataRecord(name = "France", iso = "FR", callingCode = "+33"),
    CountryDataRecord(name = "French Guiana", iso = "GF", callingCode = "+594"),
    CountryDataRecord(name = "French Polynesia", iso = "PF", callingCode = "+689"),
    CountryDataRecord(name = "Gabon", iso = "GA", callingCode = "+241"),
    CountryDataRecord(name = "Gambia", iso = "GM", callingCode = "+220"),
    CountryDataRecord(name = "Georgia", iso = "GE", callingCode = "+995"),
    CountryDataRecord(name = "Germany", iso = "DE", callingCode = "+49"),
    CountryDataRecord(name = "Ghana", iso = "GH", callingCode = "+233"),
    CountryDataRecord(name = "Gibraltar", iso = "GI", callingCode = "+350"),
    CountryDataRecord(name = "Greece", iso = "GR", callingCode = "+30"),
    CountryDataRecord(name = "Greenland", iso = "GL", callingCode = "+299"),
    CountryDataRecord(name = "Grenada", iso = "GD", callingCode = "+1"),
    CountryDataRecord(name = "Guadeloupe", iso = "GP", callingCode = "+590"),
    CountryDataRecord(name = "Guam", iso = "GU", callingCode = "+1"),
    CountryDataRecord(name = "Guatemala", iso = "GT", callingCode = "+502"),
    CountryDataRecord(name = "Guernsey", iso = "GG", callingCode = "+44"),
    CountryDataRecord(name = "Guinea", iso = "GN", callingCode = "+224"),
    CountryDataRecord(name = "Guinea-Bissau", iso = "GW", callingCode = "+245"),
    CountryDataRecord(name = "Guyana", iso = "GY", callingCode = "+592"),
    CountryDataRecord(name = "Haiti", iso = "HT", callingCode = "+509"),
    CountryDataRecord(name = "Honduras", iso = "HN", callingCode = "+504"),
    CountryDataRecord(name = "Hong Kong", iso = "HK", callingCode = "+852"),
    CountryDataRecord(name = "Hungary", iso = "HU", callingCode = "+36"),
    CountryDataRecord(name = "Iceland", iso = "IS", callingCode = "+354"),
    CountryDataRecord(name = "India", iso = "IN", callingCode = "+91"),
    CountryDataRecord(name = "Indonesia", iso = "ID", callingCode = "+62"),
    CountryDataRecord(name = "Iran", iso = "IR", callingCode = "+98"),
    CountryDataRecord(name = "Iraq", iso = "IQ", callingCode = "+964"),
    CountryDataRecord(name = "Ireland", iso = "IE", callingCode = "+353"),
    CountryDataRecord(name = "Isle of Man", iso = "IM", callingCode = "+44"),
    CountryDataRecord(name = "Israel", iso = "IL", callingCode = "+972"),
    CountryDataRecord(name = "Italy", iso = "IT", callingCode = "+39"),
    CountryDataRecord(name = "Jamaica", iso = "JM", callingCode = "+1"),
    CountryDataRecord(name = "Japan", iso = "JP", callingCode = "+81"),
    CountryDataRecord(name = "Jersey", iso = "JE", callingCode = "+44"),
    CountryDataRecord(name = "Jordan", iso = "JO", callingCode = "+962"),
    CountryDataRecord(name = "Kazakhstan", iso = "KZ", callingCode = "+7"),
    CountryDataRecord(name = "Kenya", iso = "KE", callingCode = "+254"),
    CountryDataRecord(name = "Kiribati", iso = "KI", callingCode = "+686"),
    CountryDataRecord(name = "Kosovo", iso = "XK", callingCode = "+383"),
    CountryDataRecord(name = "Kuwait", iso = "KW", callingCode = "+965"),
    CountryDataRecord(name = "Kyrgyzstan", iso = "KG", callingCode = "+996"),
    CountryDataRecord(name = "Laos", iso = "LA", callingCode = "+856"),
    CountryDataRecord(name = "Latvia", iso = "LV", callingCode = "+371"),
    CountryDataRecord(name = "Lebanon", iso = "LB", callingCode = "+961"),
    CountryDataRecord(name = "Lesotho", iso = "LS", callingCode = "+266"),
    CountryDataRecord(name = "Liberia", iso = "LR", callingCode = "+231"),
    CountryDataRecord(name = "Libya", iso = "LY", callingCode = "+218"),
    CountryDataRecord(name = "Liechtenstein", iso = "LI", callingCode = "+423"),
    CountryDataRecord(name = "Lithuania", iso = "LT", callingCode = "+370"),
    CountryDataRecord(name = "Luxembourg", iso = "LU", callingCode = "+352"),
    CountryDataRecord(name = "Macau", iso = "MO", callingCode = "+853"),
    CountryDataRecord(name = "Madagascar", iso = "MG", callingCode = "+261"),
    CountryDataRecord(name = "Malawi", iso = "MW", callingCode = "+265"),
    CountryDataRecord(name = "Malaysia", iso = "MY", callingCode = "+60"),
    CountryDataRecord(name = "Maldives", iso = "MV", callingCode = "+960"),
    CountryDataRecord(name = "Mali", iso = "ML", callingCode = "+223"),
    CountryDataRecord(name = "Malta", iso = "MT", callingCode = "+356"),
    CountryDataRecord(name = "Marshall Islands", iso = "MH", callingCode = "+692"),
    CountryDataRecord(name = "Martinique", iso = "MQ", callingCode = "+596"),
    CountryDataRecord(name = "Mauritania", iso = "MR", callingCode = "+222"),
    CountryDataRecord(name = "Mauritius", iso = "MU", callingCode = "+230"),
    CountryDataRecord(name = "Mayotte", iso = "YT", callingCode = "+262"),
    CountryDataRecord(name = "Mexico", iso = "MX", callingCode = "+52"),
    CountryDataRecord(name = "Micronesia", iso = "FM", callingCode = "+691"),
    CountryDataRecord(name = "Moldova", iso = "MD", callingCode = "+373"),
    CountryDataRecord(name = "Monaco", iso = "MC", callingCode = "+377"),
    CountryDataRecord(name = "Mongolia", iso = "MN", callingCode = "+976"),
    CountryDataRecord(name = "Montenegro", iso = "ME", callingCode = "+382"),
    CountryDataRecord(name = "Montserrat", iso = "MS", callingCode = "+1"),
    CountryDataRecord(name = "Morocco", iso = "MA", callingCode = "+212"),
    CountryDataRecord(name = "Mozambique", iso = "MZ", callingCode = "+258"),
    CountryDataRecord(name = "Myanmar", iso = "MM", callingCode = "+95"),
    CountryDataRecord(name = "Namibia", iso = "NA", callingCode = "+264"),
    CountryDataRecord(name = "Nauru", iso = "NR", callingCode = "+674"),
    CountryDataRecord(name = "Nepal", iso = "NP", callingCode = "+977"),
    CountryDataRecord(name = "Netherlands", iso = "NL", callingCode = "+31"),
    CountryDataRecord(name = "New Caledonia", iso = "NC", callingCode = "+687"),
    CountryDataRecord(name = "New Zealand", iso = "NZ", callingCode = "+64"),
    CountryDataRecord(name = "Nicaragua", iso = "NI", callingCode = "+505"),
    CountryDataRecord(name = "Niger", iso = "NE", callingCode = "+227"),
    CountryDataRecord(name = "Nigeria", iso = "NG", callingCode = "+234"),
    CountryDataRecord(name = "Niue", iso = "NU", callingCode = "+683"),
    CountryDataRecord(name = "Norfolk Island", iso = "NF", callingCode = "+672"),
    CountryDataRecord(name = "North Korea", iso = "KP", callingCode = "+850"),
    CountryDataRecord(name = "North Macedonia", iso = "MK", callingCode = "+389"),
    CountryDataRecord(name = "Northern Mariana Islands", iso = "MP", callingCode = "+1"),
    CountryDataRecord(name = "Norway", iso = "NO", callingCode = "+47"),
    CountryDataRecord(name = "Oman", iso = "OM", callingCode = "+968"),
    CountryDataRecord(name = "Pakistan", iso = "PK", callingCode = "+92"),
    CountryDataRecord(name = "Palau", iso = "PW", callingCode = "+680"),
    CountryDataRecord(name = "Palestine", iso = "PS", callingCode = "+970"),
    CountryDataRecord(name = "Panama", iso = "PA", callingCode = "+507"),
    CountryDataRecord(name = "Papua New Guinea", iso = "PG", callingCode = "+675"),
    CountryDataRecord(name = "Paraguay", iso = "PY", callingCode = "+595"),
    CountryDataRecord(name = "Peru", iso = "PE", callingCode = "+51"),
    CountryDataRecord(name = "Philippines", iso = "PH", callingCode = "+63"),
    CountryDataRecord(name = "Poland", iso = "PL", callingCode = "+48"),
    CountryDataRecord(name = "Portugal", iso = "PT", callingCode = "+351"),
    CountryDataRecord(name = "Puerto Rico", iso = "PR", callingCode = "+1"),
    CountryDataRecord(name = "Qatar", iso = "QA", callingCode = "+974"),
    CountryDataRecord(name = "Réunion", iso = "RE", callingCode = "+262"),
    CountryDataRecord(name = "Romania", iso = "RO", callingCode = "+40"),
    CountryDataRecord(name = "Russia", iso = "RU", callingCode = "+7"),
    CountryDataRecord(name = "Rwanda", iso = "RW", callingCode = "+250"),
    CountryDataRecord(name = "Samoa", iso = "WS", callingCode = "+685"),
    CountryDataRecord(name = "San Marino", iso = "SM", callingCode = "+378"),
    CountryDataRecord(name = "São Tomé and Príncipe", iso = "ST", callingCode = "+239"),
    CountryDataRecord(name = "Saudi Arabia", iso = "SA", callingCode = "+966"),
    CountryDataRecord(name = "Senegal", iso = "SN", callingCode = "+221"),
    CountryDataRecord(name = "Serbia", iso = "RS", callingCode = "+381"),
    CountryDataRecord(name = "Seychelles", iso = "SC", callingCode = "+248"),
    CountryDataRecord(name = "Sierra Leone", iso = "SL", callingCode = "+232"),
    CountryDataRecord(name = "Singapore", iso = "SG", callingCode = "+65"),
    CountryDataRecord(name = "Sint Maarten", iso = "SX", callingCode = "+1"),
    CountryDataRecord(name = "Slovakia", iso = "SK", callingCode = "+421"),
    CountryDataRecord(name = "Slovenia", iso = "SI", callingCode = "+386"),
    CountryDataRecord(name = "Solomon Islands", iso = "SB", callingCode = "+677"),
    CountryDataRecord(name = "Somalia", iso = "SO", callingCode = "+252"),
    CountryDataRecord(name = "South Africa", iso = "ZA", callingCode = "+27"),
    CountryDataRecord(name = "South Korea", iso = "KR", callingCode = "+82"),
    CountryDataRecord(name = "South Sudan", iso = "SS", callingCode = "+211"),
    CountryDataRecord(name = "Spain", iso = "ES", callingCode = "+34"),
    CountryDataRecord(name = "Sri Lanka", iso = "LK", callingCode = "+94"),
    CountryDataRecord(name = "Saint Barthélemy", iso = "BL", callingCode = "+590"),
    CountryDataRecord(name = "Saint Helena, Ascension and Tristan da Cunha", iso = "SH", callingCode = "+290"),
    CountryDataRecord(name = "Saint Kitts and Nevis", iso = "KN", callingCode = "+1"),
    CountryDataRecord(name = "Saint Lucia", iso = "LC", callingCode = "+1"),
    CountryDataRecord(name = "Saint Martin", iso = "MF", callingCode = "+590"),
    CountryDataRecord(name = "Saint Pierre and Miquelon", iso = "PM", callingCode = "+508"),
    CountryDataRecord(name = "Saint Vincent and the Grenadines", iso = "VC", callingCode = "+1"),
    CountryDataRecord(name = "Sudan", iso = "SD", callingCode = "+249"),
    CountryDataRecord(name = "Suriname", iso = "SR", callingCode = "+597"),
    CountryDataRecord(name = "Svalbard and Jan Mayen", iso = "SJ", callingCode = "+47"),
    CountryDataRecord(name = "Sweden", iso = "SE", callingCode = "+46"),
    CountryDataRecord(name = "Switzerland", iso = "CH", callingCode = "+41"),
    CountryDataRecord(name = "Syria", iso = "SY", callingCode = "+963"),
    CountryDataRecord(name = "Taiwan", iso = "TW", callingCode = "+886"),
    CountryDataRecord(name = "Tajikistan", iso = "TJ", callingCode = "+992"),
    CountryDataRecord(name = "Tanzania", iso = "TZ", callingCode = "+255"),
    CountryDataRecord(name = "Thailand", iso = "TH", callingCode = "+66"),
    CountryDataRecord(name = "Timor-Leste", iso = "TL", callingCode = "+670"),
    CountryDataRecord(name = "Togo", iso = "TG", callingCode = "+228"),
    CountryDataRecord(name = "Tokelau", iso = "TK", callingCode = "+690"),
    CountryDataRecord(name = "Tonga", iso = "TO", callingCode = "+676"),
    CountryDataRecord(name = "Trinidad and Tobago", iso = "TT", callingCode = "+1"),
    CountryDataRecord(name = "Tunisia", iso = "TN", callingCode = "+216"),
    CountryDataRecord(name = "Türkiye", iso = "TR", callingCode = "+90"),
    CountryDataRecord(name = "Turkmenistan", iso = "TM", callingCode = "+993"),
    CountryDataRecord(name = "Turks and Caicos Islands", iso = "TC", callingCode = "+1"),
    CountryDataRecord(name = "Tuvalu", iso = "TV", callingCode = "+688"),
    CountryDataRecord(name = "United States Virgin Islands", iso = "VI", callingCode = "+1"),
    CountryDataRecord(name = "Uganda", iso = "UG", callingCode = "+256"),
    CountryDataRecord(name = "Ukraine", iso = "UA", callingCode = "+380"),
    CountryDataRecord(name = "United Arab Emirates", iso = "AE", callingCode = "+971"),
    CountryDataRecord(name = "United Kingdom", iso = "GB", callingCode = "+44"),
    CountryDataRecord(name = "United States", iso = "US", callingCode = "+1"),
    CountryDataRecord(name = "Uruguay", iso = "UY", callingCode = "+598"),
    CountryDataRecord(name = "Uzbekistan", iso = "UZ", callingCode = "+998"),
    CountryDataRecord(name = "Vanuatu", iso = "VU", callingCode = "+678"),
    CountryDataRecord(name = "Vatican City", iso = "VA", callingCode = "+39"),
    CountryDataRecord(name = "Venezuela", iso = "VE", callingCode = "+58"),
    CountryDataRecord(name = "Vietnam", iso = "VN", callingCode = "+84"),
    CountryDataRecord(name = "Wallis and Futuna", iso = "WF", callingCode = "+681"),
    CountryDataRecord(name = "Western Sahara", iso = "EH", callingCode = "+212"),
    CountryDataRecord(name = "Yemen", iso = "YE", callingCode = "+967"),
    CountryDataRecord(name = "Zambia", iso = "ZM", callingCode = "+260"),
    CountryDataRecord(name = "Zimbabwe", iso = "ZW", callingCode = "+263")
)
